import {
    state as contextMenuState,
    DiagramContextMenuType,
    reset as resetContextMenuState,
} from '@diagram/state/context-menu';

const ContextMenuService = {
    openGenericContextMenu: (position: typeof contextMenuState.position) => {
        contextMenuState.position = position;
        contextMenuState.type = DiagramContextMenuType.GENERIC;
    },

    openComponentInstanceContextMenu: (
        position: typeof contextMenuState.position,
        componentInstance: typeof contextMenuState.componentInstance,
    ) => {
        contextMenuState.position = position;
        contextMenuState.type = DiagramContextMenuType.COMPONENT_INSTANCE;
        contextMenuState.componentInstance = componentInstance;
    },

    closeContextMenu: () => {
        resetContextMenuState();
    },
};

export { ContextMenuService };
